import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SweetAlertResult } from 'sweetalert2';

import { CustomerModel } from '@models/CustomerModel';
import { SharedService } from '@services/shared.service';
import { ApiAuthService } from '@services/api-auth.service';


@Component({
    selector: 'app-user-nav-profile',
    templateUrl: './user-nav-profile.component.html',
    styleUrls: ['./user-nav-profile.component.scss'],
})
export class UserNavProfileComponent implements OnInit, OnDestroy {

    @Input() profile: CustomerModel;

    @Input() hideLogin = false;
    
    showGift: boolean = false;

    private hideHamburgerMenuSubscription: Subscription = null;

    constructor(
        private router: Router,
        public sharedService: SharedService) {
    }

    ngOnInit(): void {
        
        // hide gift
        this.hideHamburgerMenuSubscription = this.sharedService.hideHamburgerMenu.subscribe((hide) => {
            // this.showGift = !hide;
            this.showGift = false;
        });
    }

    ngOnDestroy(): void {
        
        if (this.hideHamburgerMenuSubscription) { this.hideHamburgerMenuSubscription.unsubscribe(); }
    }

    onLogin() {

        this.router.navigate(['login']);
    }

    onLogout() {

        this.sharedService.showConfirmAlert(
            null,
            `¿Deseás cerrar la sesión?`
        ).then(
            (result: SweetAlertResult) => {

                if (result && result.value) {

                    this.sharedService.showErrorAlert(null, 'Error al cargar la información solicitada').then(()=>{
                        this.router.navigate(['/market']);
                    });
                }
            }
        );
    }

    goToGivis() {

        this.router.navigate(['/givis'])
    }
}
